import { render, staticRenderFns } from "./ValidationErrorMessage.vue?vue&type=template&id=2a588ec4&"
import script from "./ValidationErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ValidationErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports